<template>
  <v-dialog v-model="growthValues.dialog"
            width="1058">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold py-4">
        <v-spacer></v-spacer>
        Growth System & Growth Value Rules
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="px-4 py-0">
        <p>In Acadsoc, tutors can gain growth values every time when they complete a course or special project. Good grades from students or parents can give you extra values. However, not being punctual or not fulfilling the timetable you specify will make your efforts in vain.</p>
        <p class="mb-0">At the beginning, every tutor starts at level 1 (LV.1). After gaining the growth value, they will be promoted to level 8 (LV.8). The higher the level, the more rights you will gain while you improve yourself.</p>
      </v-card-text>
      <v-card-text class="pa-4">
        <v-layout row class="growth-rules">
          <v-flex xs6>
            <v-data-table :headers="headers"
                      :items="desserts"
                      hide-actions
                      class="common-table left-table">
              <template slot="items"
                        slot-scope="props">
                <td class="blue-title">{{ props.item.concern }}</td>
                <td class="blue-title" v-html="props.item.points"></td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs6>
            <v-data-table :headers="headers"
                      :items="desserts2"
                      hide-actions
                      class="common-table right-table">
              <template slot="items"
                        slot-scope="props">
                <td class="blue-title">{{ props.item.concern }}</td>
                <td class="blue-title" v-html="props.item.points"></td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'values',
  props: {
    growthValues: {
      dialog: false
    }
  },
  data: () => ({
    headers: [
      {
        text: 'Data in Concern',
        align: 'left',
        sortable: false,
        value: 'concern'
      },
      {
        text: 'Points Gained',
        align: 'left',
        sortable: false,
        value: 'points'
      }
    ],
    desserts: [
      {
        concern: 'Pass QA Test, Pass TL',
        points: '+3 Points'
      }, {
        concern: 'Pass TESOL',
        points: '+5 Points'
      }, {
        concern: 'Complete Personal Information',
        points: '+2 Points'
      }, {
        concern: 'Contract Signing',
        points: '+2 Points'
      }, 
      {
        concern: 'Complete Popular Course Training',
        points: '+5 Points'
      },
      {
        concern:'Complete the First Class',
        points: '+0.5 Points'
      },
      {
        concern: 'Leave Class Remarks after Class',
        points: '+0.25 Points/+0.5 Points'
      },
      {
        concern: 'Get a Pet',
        points: '+1 Points'
      },
      {
        concern: 'Confirmation of Available Class Schedule',
        points: '+1 Points'
      },
      {
        concern: 'Course Learning',
        points: '+(2~5) Points'
      }, 
      {
        concern: 'Clock in on Time Every Day',
        points: '+0.2 Points'
      },
      {
        concern: 'Finish Class',
        points: '+0.5 Points/+0.75 Points'
      }, 
      {
        concern: 'Get 5 Stars',
        points: '+4 Points'
      }, 
      {
        concern: 'Taking Photos with Students in Class Happily',
        points: '+0.25 Points'
      }, 
      {
        concern: 'Confirmation of Available Class Schedule',
        points: '+1 Points'
      },
    ],
    desserts2:[{
        concern: 'Successful Trial Conversion',
        points: '+2 Points'
      }, 
      {
        concern: 'Schedule Classes One Week in Advance',
        points: '+2 Points'
      }, 
      {
        concern: 'Get Flowers',
        points: '+4 Points'
      },
      {
        concern: 'Weekly Task-Complete 80 Lessons',
        points: '+5 Points'
      }, {
        concern: 'Weekly Tasks-Gain at Least 72 Positive Feedback',
        points: '+5 Points'
      },{
        concern: 'MT Training Assessment',
        points: '+(3~8) Points'
      }, {
        concern: 'Refer a Teacher and Open an Account Successfully',
        points: '+1 Points'
      }, {
        concern: 'Refer a Teacher and Start the Class Successfully',
        points: '+20 Points'
      },   {
        concern: 'Absence',
        points: '-8 Points'
      }, {
        concern: 'Cancellation (courses within 3 hours within 24 hours)',
        points: '-4 Points'
      }, {
        concern: 'Cancellation (courses within 3h)',
        points: '-3 Points'
      },{
        concern: 'Complaint',
        points: '-5 Points'
      }, {
        concern: 'No Class for 7 Consecutive Days',
        points: '-5 Points'
      },
      {
        concern:'The Teacher Returns',
        points: '0'
      },
      {
        concern:'',
        points: ''
      }
    ]
  }),
  methods: {
    show () {
      this.growthValues.dialog = true
    }
  }
}
</script>
<style>
.right-table .v-table__overflow{
  width:475px;
}
</style>
<style lang="scss" scoped>
.blue-title{
    @include font_color($font-color-theme);
}
.common-table{
  box-shadow: none !important;
}
.growth-rules{
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.3) !important;
  border-radius: 16px;
}
.left-table{
  border-right: none !important;
  padding-right: 0;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.right-table{
  border-left: none !important;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
